import { Injectable } from '@angular/core'
import { AnyObject } from '@naturalcycles/js-lib'
import { ExternalPersonalId } from '@naturalcycles/shared'
import { sentry } from '@src/app/core/util/sentry.util.js'
import { env } from '@src/environments/environment.js'

interface AddShoppersConversionModel {
  order_id: ExternalPersonalId
  value: string
  email?: string
  currency: string
  allow_referral?: boolean
  custom_fields?: { [key: string]: string }
}

interface AddShoppersProduct {
  allow_referral: number
  callback: string
  value: string
  orderid: string
  currency: string
  product?: string | null
  product_url?: string | null
  shortid?: string | null
  siteid: string
  url: string
  user_email: string
  custom_fields: string
}

/* eslint-disable @typescript-eslint/naming-convention */
interface AddShoppersWidget {
  id: string
  session_id: string
  url: string
  product: string
  short_link: string
  Storage: {
    get: (key: string) => (AddShoppersProduct & AnyObject) | null
  }
  ajax_js: (a: any) => Promise<void>
  track_conv: () => void
  prepare_url: (s: string, o: AddShoppersProduct) => AddShoppersProduct & AnyObject
  _takeback_limit_reset: () => void
}
/* eslint-enable @typescript-eslint/naming-convention */

type AddShoppersWindow = Window &
  typeof globalThis & {
    AddShoppersWidget?: AddShoppersWidget
  }

@Injectable({ providedIn: 'root' })
export class AddShoppersService {
  load(country?: string): void {
    // AddShoppers will run Only in US
    if (country !== 'US') {
      return
    }
    // They expect the script to be exactly on this
    // position loadScript did not work here
    const t = document.createElement('script')
    t.type = 'text/javascript'
    t.async = true
    t.id = 'AddShoppers'
    t.src = 'https://shop.pe/widget/widget_async.js#622242ae73efc3646959c111'
    document.getElementsByTagName('head')[0]?.appendChild(t)
  }

  async trackConversion(conversion: AddShoppersConversionModel): Promise<void> {
    try {
      const addShoppersWidget = (window as AddShoppersWindow).AddShoppersWidget

      // * Only US customers load the addShoppers plugin
      if (!addShoppersWidget) {
        return
      }
      // AddShoppersWidget.track_conv() requires a "global" VAR.
      // To bypass it, we are using the track_conv() code in here
      const lastProductData = addShoppersWidget.Storage.get('AddShoppersWidget_lastProductData')

      await addShoppersWidget.ajax_js(
        addShoppersWidget.prepare_url('widget/conv/params', {
          allow_referral: 0,
          callback: 'AddShoppersWidget.Integration.pixels',
          value: conversion.value,
          orderid: conversion.order_id,
          currency: conversion.currency,
          product: lastProductData?.product,
          product_url: lastProductData?.product_url,
          shortid: lastProductData?.shortid,
          siteid: addShoppersWidget.id,
          url: addShoppersWidget.url,
          user_email: conversion.email || '',
          custom_fields: JSON.stringify({ environment: env.name }),
        }),
      )
      localStorage.removeItem('isErcEmail')
      addShoppersWidget._takeback_limit_reset()
    } catch (err) {
      // Suppresses AddShoppersWidget undefined error.
      // 99% of the cases should be handled by * (above)
      if (err instanceof ReferenceError) {
        return
      }
      sentry.captureException(err)
    }
  }
}
